/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { EdrDeploymentTypeEnum } from '../model/edrDeploymentTypeEnum';
// @ts-ignore
import { EdrOrgWithApiKeys } from '../model/edrOrgWithApiKeys';
// @ts-ignore
import { EdrOrgsValidateResponse } from '../model/edrOrgsValidateResponse';
// @ts-ignore
import { ErrorResponse } from '../model/errorResponse';
// @ts-ignore
import { OnPremEdrOrgsListResponse } from '../model/onPremEdrOrgsListResponse';
// @ts-ignore
import { OperatorDeprovisionEdrOrgSpec } from '../model/operatorDeprovisionEdrOrgSpec';
// @ts-ignore
import { OperatorOnPremApiKeyDeleteSpec } from '../model/operatorOnPremApiKeyDeleteSpec';
// @ts-ignore
import { OperatorOnPremEdrOrgSpec } from '../model/operatorOnPremEdrOrgSpec';
// @ts-ignore
import { TaskV2 } from '../model/taskV2';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class RansomwareRecoveryOnpremOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Create ONPREM API key for EDR organization (Operator)
     * Create a new ONPREM API key for the specified Carbon Black EDR organization. Not supported for CrowdStrike. Returns an async task reference. Only supported for managed-mode organizations. 
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param vlcrOrgId VLCR Organization identifier
     * @param deploymentType EDR deployment type for on-premises API key management. Must be ON_PREM.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public createOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public createOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public createOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling createOnPremApiKeyOperator.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling createOnPremApiKeyOperator.');
        }
        if (vlcrOrgId === null || vlcrOrgId === undefined) {
            throw new Error('Required parameter vlcrOrgId was null or undefined when calling createOnPremApiKeyOperator.');
        }
        if (deploymentType === null || deploymentType === undefined) {
            throw new Error('Required parameter deploymentType was null or undefined when calling createOnPremApiKeyOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlcrOrgId, 'vlcr_org_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentType, 'deployment_type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete ONPREM API key for EDR organization (Operator)
     * Delete an ONPREM API key for the specified Carbon Black EDR organization. Not supported for CrowdStrike. Returns an async task reference. Only supported for managed-mode organizations. 
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param apiKeyId API key ID (format ONPREM:&lt;UUID&gt; for Carbon Black on-premises keys)
     * @param operatorOnPremApiKeyDeleteSpec Delete spec (includes vlcr_org_id and optional control flags)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, operatorOnPremApiKeyDeleteSpec: OperatorOnPremApiKeyDeleteSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public deleteOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, operatorOnPremApiKeyDeleteSpec: OperatorOnPremApiKeyDeleteSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public deleteOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, operatorOnPremApiKeyDeleteSpec: OperatorOnPremApiKeyDeleteSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public deleteOnPremApiKeyOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, apiKeyId: string, operatorOnPremApiKeyDeleteSpec: OperatorOnPremApiKeyDeleteSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deleteOnPremApiKeyOperator.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling deleteOnPremApiKeyOperator.');
        }
        if (apiKeyId === null || apiKeyId === undefined) {
            throw new Error('Required parameter apiKeyId was null or undefined when calling deleteOnPremApiKeyOperator.');
        }
        if (operatorOnPremApiKeyDeleteSpec === null || operatorOnPremApiKeyDeleteSpec === undefined) {
            throw new Error('Required parameter operatorOnPremApiKeyDeleteSpec was null or undefined when calling deleteOnPremApiKeyOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys/${this.configuration.encodeParam({name: "apiKeyId", value: apiKeyId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaskV2>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: operatorOnPremApiKeyDeleteSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Deprovision EDR organization (Operator)
     * Deprovision an EDR organization (Operator). Deactivates all active ONPREM api-keys synchronously, then deprovisions the EDR org from the vendor cloud and deletes it from RMS. Returns a task reference in terminal state (DONE/FAILED). The EDR org must have no active cloud (non-ONPREM) deployments; deactivate them first if present. 
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param operatorDeprovisionEdrOrgSpec Deprovision spec (includes vlcr_org_id and optional control flags)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deprovisionEdrOrgOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, operatorDeprovisionEdrOrgSpec: OperatorDeprovisionEdrOrgSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public deprovisionEdrOrgOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, operatorDeprovisionEdrOrgSpec: OperatorDeprovisionEdrOrgSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public deprovisionEdrOrgOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, operatorDeprovisionEdrOrgSpec: OperatorDeprovisionEdrOrgSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public deprovisionEdrOrgOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, operatorDeprovisionEdrOrgSpec: OperatorDeprovisionEdrOrgSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling deprovisionEdrOrgOperator.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling deprovisionEdrOrgOperator.');
        }
        if (operatorDeprovisionEdrOrgSpec === null || operatorDeprovisionEdrOrgSpec === undefined) {
            throw new Error('Required parameter operatorDeprovisionEdrOrgSpec was null or undefined when calling deprovisionEdrOrgOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<TaskV2>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: operatorDeprovisionEdrOrgSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List assigned EDR organizations (Operator)
     * List all EDR organizations assigned to a VLC org for the given vendor
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param vlcrOrgId VLCR Organization identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getEdrOrgsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<OnPremEdrOrgsListResponse>;
    public getEdrOrgsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<OnPremEdrOrgsListResponse>>;
    public getEdrOrgsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<OnPremEdrOrgsListResponse>>;
    public getEdrOrgsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling getEdrOrgsOperator.');
        }
        if (vlcrOrgId === null || vlcrOrgId === undefined) {
            throw new Error('Required parameter vlcrOrgId was null or undefined when calling getEdrOrgsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlcrOrgId, 'vlcr_org_id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs`;
        return this.httpClient.request<OnPremEdrOrgsListResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List EDR organization API keys (Operator)
     * List all API keys for the specified EDR organization. For Carbon Black, returns only ONPREM api keys. For CrowdStrike, returns the single GLOBAL key. Only supported for managed-mode organizations. 
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param edrOrgId EDR organization ID
     * @param vlcrOrgId VLCR Organization identifier
     * @param deploymentType EDR deployment type for on-premises API key management. Must be ON_PREM.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listApiKeysOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EdrOrgWithApiKeys>;
    public listApiKeysOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrOrgWithApiKeys>>;
    public listApiKeysOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrOrgWithApiKeys>>;
    public listApiKeysOperator(edrVendor: 'cs' | 'cb', edrOrgId: string, vlcrOrgId: string, deploymentType: EdrDeploymentTypeEnum, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling listApiKeysOperator.');
        }
        if (edrOrgId === null || edrOrgId === undefined) {
            throw new Error('Required parameter edrOrgId was null or undefined when calling listApiKeysOperator.');
        }
        if (vlcrOrgId === null || vlcrOrgId === undefined) {
            throw new Error('Required parameter vlcrOrgId was null or undefined when calling listApiKeysOperator.');
        }
        if (deploymentType === null || deploymentType === undefined) {
            throw new Error('Required parameter deploymentType was null or undefined when calling listApiKeysOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlcrOrgId, 'vlcr_org_id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentType, 'deployment_type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs/${this.configuration.encodeParam({name: "edrOrgId", value: edrOrgId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/api-keys`;
        return this.httpClient.request<EdrOrgWithApiKeys>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * List EDR regions (Operator)
     * List available VMware-managed EDR regions for the specified vendor.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param vlcrOrgId VLCR Organization identifier
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public listEdrRegionsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<EdrOrgsValidateResponse>;
    public listEdrRegionsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<EdrOrgsValidateResponse>>;
    public listEdrRegionsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<EdrOrgsValidateResponse>>;
    public listEdrRegionsOperator(edrVendor: 'cs' | 'cb', vlcrOrgId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling listEdrRegionsOperator.');
        }
        if (vlcrOrgId === null || vlcrOrgId === undefined) {
            throw new Error('Required parameter vlcrOrgId was null or undefined when calling listEdrRegionsOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vlcrOrgId, 'vlcr_org_id');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-regions`;
        return this.httpClient.request<EdrOrgsValidateResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Provision EDR organization (Operator)
     * Provision a new EDR organization for on-premises deployment. Returns an exception if an EDR org is already provisioned for the given organization and region.
     * @param edrVendor EDR vendor to use. cs - CrowdStrike and cb - Carbon Black.
     * @param operatorOnPremEdrOrgSpec EDR organization specification (includes vlcr_org_id for operator)
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public provisionEdrOrgOperator(edrVendor: 'cs' | 'cb', operatorOnPremEdrOrgSpec: OperatorOnPremEdrOrgSpec, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<TaskV2>;
    public provisionEdrOrgOperator(edrVendor: 'cs' | 'cb', operatorOnPremEdrOrgSpec: OperatorOnPremEdrOrgSpec, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<TaskV2>>;
    public provisionEdrOrgOperator(edrVendor: 'cs' | 'cb', operatorOnPremEdrOrgSpec: OperatorOnPremEdrOrgSpec, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<TaskV2>>;
    public provisionEdrOrgOperator(edrVendor: 'cs' | 'cb', operatorOnPremEdrOrgSpec: OperatorOnPremEdrOrgSpec, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (edrVendor === null || edrVendor === undefined) {
            throw new Error('Required parameter edrVendor was null or undefined when calling provisionEdrOrgOperator.');
        }
        if (operatorOnPremEdrOrgSpec === null || operatorOnPremEdrOrgSpec === undefined) {
            throw new Error('Required parameter operatorOnPremEdrOrgSpec was null or undefined when calling provisionEdrOrgOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rwr/${this.configuration.encodeParam({name: "edrVendor", value: edrVendor, in: "path", style: "simple", explode: false, dataType: "'cs' | 'cb'", dataFormat: undefined})}/edr-orgs`;
        return this.httpClient.request<TaskV2>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: operatorOnPremEdrOrgSpec,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
